export default __webpack_public_path__ + "img/tired.5a73c5ce.svg";